// PATH
export const PATH_GOOGLE_AUTH = process.env.REACT_APP_SOCIAL_GOOGLE_AUTH_URL;
export const PATH_FB_AUTH = process.env.REACT_APP_SOCIAL_FB_AUTH_URL;
export const PATH_MAIN_DOMAIN = window?.href?.includes('localhost') ? 'https://www.sofiadate.com' : process.env.REACT_APP_PATH_MAIN_DOMAIN;

// UTM_TAG
export const GMAIL = 'gmail';
export const FB = 'fb';
